import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Emitter from './Emitter';

export default class ManRocket extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.rocket = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._man_rocket, this).setOrigin(0);

    this.manInWindow = ABCyaPhaser.Images.addImage(145 + 15,198 + 6,UIAssetKeys._man_in_window, this).setOrigin(0);
  }

  liftOffIntro () {
    this.scene.time.delayedCall(1000, () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._take_off, this.scene));

    this.flame = ABCyaPhaser.Images.addImage(110,550, UIAssetKeys._flames, this).setOrigin(0);
    this.flame.alpha = 0;
    this.flame.angle = -20;

    this.moveTo(this.flame, 0);

    this.manInWindow.alpha = 1;

    const flameLoop = () => {
      ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 0.8 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 1.2 }, Phaser.Math.Easing.Linear, () => {
          flameLoop();
        });
      });
    };
    flameLoop();

    ABCyaPhaser.Tweens.addTween(this.flame, 10, { delay: 1600, alpha: 1 }, Phaser.Math.Easing.Linear);

    let loopsRemaining = 8;
    const xPos = this.x;
    const thisLoop = () => {
      const duration = 50;
      ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos - 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos + 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
          loopsRemaining--;
          if (loopsRemaining > 0) {
            thisLoop();
          }
        });
      });
    };
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.tweens.killTweensOf([this, this.flame]));
    this.scene.time.delayedCall(900, () => thisLoop());

    ABCyaPhaser.Tweens.addTween(this, 3500, { delay: 600, y: this.y - 2000 }, Phaser.Math.Easing.Linear, () => this.destroy());
  }

  land () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._landing, this.scene, 1, false, 0.9);

    this.flame = ABCyaPhaser.Images.addImage(110, 550, UIAssetKeys._flames, this).setOrigin(0);
    this.flame.alpha = 0;
    this.flame.angle = -20;
    this.flame.scale = 1.2;

    this.moveTo(this.flame, 0);

    ABCyaPhaser.Tweens.addTween(this.manInWindow, 200, { alpha: 1 }, Phaser.Math.Easing.Linear);

    ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 0.8, loop: 7, yoyo: true }, Phaser.Math.Easing.Linear, () => this.flame.destroy());

    ABCyaPhaser.Tweens.addTween(this.flame, 10, { alpha: 1 }, Phaser.Math.Easing.Linear, () => {
      this.makeSmoke(500,550);
      this.scene.time.delayedCall(4000, () => {
        this.emitter.destroy();
      });
    });

    let loopsRemaining = 8;
    const xPos = this.x;
    const thisLoop = () => {
      const duration = 50;
      ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos - 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this, duration, { x: xPos + 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
          loopsRemaining--;
          if (loopsRemaining > 0) {
            thisLoop();
          }
        });
      });
    };
    thisLoop();

    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.tweens.killTweensOf([this, this.flame]));

    const endX = this.x + 600;
    const endY = this.y + 1100;

    ABCyaPhaser.Tweens.addTween(this, 4000, { y: this.y + 850, completeDelay: 1000 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this, 1000, { x: endX, y: endY, scale: 0.5 }, Phaser.Math.Easing.Linear);

      // ABCyaPhaser.Tweens.addTween(this, 1000, {  scale: 0.5 }, Phaser.Math.Easing.Linear);
    });


    ABCyaPhaser.Tweens.addTween(this.manInWindow, 500, { delay: 6000, alpha: 0 }, Phaser.Math.Easing.Linear);
  }

  makeSmoke (x, y) {
    this.emitter = new Emitter(this.scene);
    this.emitter.x = x;
    this.emitter.y = y;

    this.add(this.emitter);
    this.emitter.emitSmoke();
  }

  liftOff () {
    this.scene.time.delayedCall(1000, () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._take_off, this.scene));

    this.flame = ABCyaPhaser.Images.addImage(110,550, UIAssetKeys._flames, this).setOrigin(0);
    this.flame.alpha = 0;
    this.flame.angle = -20;

    this.moveTo(this.flame, 0);

    this.manInWindow.alpha = 1;

    const endX = this.x - 550;
    const endY = this.y - 250;

    ABCyaPhaser.Tweens.addTween(this, 1000, { x: endX, y: endY, scale: 1 }, Phaser.Math.Easing.Linear);

    const flameLoop = () => {
      ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 0.8 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this.flame, 300, { scaleY: 1.2 }, Phaser.Math.Easing.Linear, () => {
          flameLoop();
        });
      });
    };
    flameLoop();
    ABCyaPhaser.Tweens.addTween(this.flame, 10, { delay: 1600, alpha: 1 }, Phaser.Math.Easing.Linear, () => {
      this.makeSmoke(500,550);
      this.scene.time.delayedCall(5000, () => this.emitter.destroy());
    });

    let loopsRemaining = 8;
    const thisLoop = () => {
      const duration = 50;
      ABCyaPhaser.Tweens.addTween(this, duration, { x: endX - 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(this, duration, { x: endX + 5, completeDelay: duration }, Phaser.Math.Easing.Linear, () => {
          loopsRemaining--;
          if (loopsRemaining > 0) {
            thisLoop();
          }
        });
      });
    };

    this.scene.time.delayedCall(900, () => thisLoop());

    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.tweens.killTweensOf([this, this.flame]));

    const adjustY = 250;
    this.y -= adjustY;

    ABCyaPhaser.Tweens.addTween(this, 2500, { delay: 1600, y: this.y - 1000 }, Phaser.Math.Easing.Linear, () => this.destroy());
  }
}